<template>
    <div style="margin-top:9px;">
        <v-container grid-list-xl>
            <h2>Urejanje uporabnika</h2>
            <v-divider></v-divider>
            <br>
            <v-layout v-bind="contentLayout">
                <v-flex xs12>
                    <v-form id="updateForm" ref="form" v-model="valid" lazy-validation>
                        <v-card>
                            <v-toolbar
                            card 
                            color="grey lighten-3"
                            dense
                            >
                            <v-toolbar-title class="body-2"><v-icon medium>account_box</v-icon>   Osebni podatki</v-toolbar-title>
                            </v-toolbar>
                            <v-card-text>
                                <!-- imetnik -->
                                <v-text-field
                                    v-model="imetnik"
                                    label="Imetnik (ime in priimek)"
                                    :rules="imetnikRules"
                                    required
                                ></v-text-field>

                                <!-- ulica -->
                                <v-text-field
                                    v-model="ulica"
                                    label="Ulica (stalno prebivališče)"
                                ></v-text-field>

                                <!-- kraj -->
                                <v-text-field
                                    v-model="kraj"
                                    label="Kraj (stalno prebivališče)"
                                ></v-text-field>
                                <!-- telefonska številka -->
                                <v-text-field
                                    v-model="telefonska_st"
                                    label="Telefonska številka"
                                ></v-text-field>
                                <!-- email -->
                                <v-text-field
                                    v-model="email"
                                    label="Elektronski naslov"
                                ></v-text-field>
                                <!-- emšo -->
                                <v-text-field
                                    v-model="emso"
                                    label="EMŠO"
                                ></v-text-field>
                                <!-- davčna številka -->
                                <v-text-field
                                    v-model="davcna_st"
                                    label="Davčna številka"
                                ></v-text-field>

                            </v-card-text>
                        </v-card>
                        <br>
                        <v-card>
                            <v-toolbar
                            card 
                            color="grey lighten-3"
                            dense
                            >
                            <v-toolbar-title class="body-2"><v-icon medium>time_to_leave</v-icon>   Podatki o vozilu</v-toolbar-title>
                            </v-toolbar>
                            <v-card-text>
                                <!-- registrske številke -->
                                <v-container grid-list-xl text-x-center align-center>
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex x12 align-content-center>
                                            <p>Registrske številke (do 5 reg. številk):</p>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 align-content-center>
                                            <v-text-field
                                                v-model="registrska_st_1"
                                                label="Registrska številka 1"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 align-content-center>
                                            <v-text-field
                                                v-model="registrska_st_2"
                                                label="Registrska številka 2"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 align-content-center>
                                            <v-text-field
                                                v-model="registrska_st_3"
                                                label="Registrska številka 3"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 align-content-center>
                                            <v-text-field
                                                v-model="registrska_st_4"
                                                label="Registrska številka 4"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 align-content-center>
                                            <v-text-field
                                                v-model="registrska_st_5"
                                                label="Registrska številka 5"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row justify-start v-bind="columnBinding">
                                        <v-flex xs12 align-content-end>
                                            <v-switch
                                                v-model="prepoznava_tablic"
                                                label="Dovoli vstop s prepoznavo tablic"
                                                color="primary"
                                                value="1"
                                                hide-details
                                            ></v-switch>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>
                        </v-card>
                        <br>
                        <v-card>
                            <v-toolbar
                            card 
                            color="grey lighten-3"
                            dense
                            >
                            <v-toolbar-title class="body-2"><v-icon medium>receipt</v-icon>   Podatki o dovolilnice in pripadajočih vlogah</v-toolbar-title>
                            </v-toolbar>
                            <v-card-text>
                                <!-- dovolilnica -->
                                <v-toolbar
                                    card 
                                    color="grey lighten-4"
                                    dense
                                >
                                    <v-toolbar-title class="body-2"><v-icon medium>receipt</v-icon>   Dovolilnica</v-toolbar-title>
                                </v-toolbar>
                                <v-container grid-list-xl text-x-center align-center>
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs8 align-content-center>
                                            <v-subheader><strong>Veljavnost dovolilnice</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 align-content-center>
                                            <v-menu
                                                ref="menu"
                                                :close-on-content-click="false"
                                                v-model="menu_od"
                                                :nudge-right="40"
                                                :return-value.sync="dovolilnica_veljavnost_od"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                min-width="290px"
                                                >
                                                <v-text-field
                                                    slot="activator"
                                                    v-model="dovolilnica_veljavnost_od_formatted"
                                                    label="Datum od"
                                                    prepend-icon="event"
                                                    readonly
                                                ></v-text-field>
                                                <v-date-picker v-model="dovolilnica_veljavnost_od" no-title scrollable locale="sl-si">
                                                    <v-spacer></v-spacer>
                                                    <v-btn flat color="primary" @click="menu_od = false">Prekliči</v-btn>
                                                    <v-btn flat color="primary" @click="$refs.menu.save(dovolilnica_veljavnost_od)">Potrdi</v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                        <v-flex xs12 align-content-center>
                                            <v-menu
                                                ref="menu_do"
                                                :close-on-content-click="false"
                                                v-model="menu_do"
                                                :nudge-right="40"
                                                :return-value.sync="dovolilnica_veljavnost_do"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                min-width="290px"
                                                >
                                                <v-text-field
                                                    slot="activator"
                                                    v-model="dovolilnica_veljavnost_do_formatted"
                                                    label="Datum do"
                                                    prepend-icon="event"
                                                    readonly
                                                ></v-text-field>
                                                <v-date-picker v-model="dovolilnica_veljavnost_do" no-title scrollable locale="sl-si">
                                                    <v-spacer></v-spacer>
                                                    <v-btn flat color="primary" @click="menu_do = false">Prekliči</v-btn>
                                                    <v-btn flat color="primary" @click="$refs.menu_do.save(dovolilnica_veljavnost_do)">Potrdi</v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                                <br>

                                <!-- rfid -->
                                <v-toolbar
                                    card 
                                    color="grey lighten-4"
                                    dense
                                >
                                    <v-toolbar-title class="body-2"><v-icon medium>credit_card</v-icon>   RFID kartica</v-toolbar-title>
                                </v-toolbar>
                                <v-container grid-list-xl text-x-center align-center>
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs4 align-content-center>
                                            <v-subheader><strong>ID kartice</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 align-content-center>
                                            <v-text-field
                                                v-model="id_kartice"
                                                label="ID kartice"
                                                required
                                                :disabled="inputIDkartice"
                                                ref="input_id_kartice"
                                                :rules="getSerijskaStKartice ? idKarticeRules : []"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs4 align-content-center>
                                            <v-subheader><strong>Serisjska številka kartice</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 align-content-center>
                                            <v-text-field
                                                v-model="serijska_st_kartice"
                                                label="Serijska št. kartice"
                                                required
                                                :disabled="inputSerijskaStkartice"
                                                ref="input_serijska_st_kartice"
                                                @keyup.enter.native="RfidNr"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs4 align-content-center>
                                            <v-subheader><strong>Kartica blokirana</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 align-content-center>
                                            <v-switch
                                                v-model="kartica_blokirana"
                                                label="Blokiraj kartico"
                                                color="primary"
                                                value="1"
                                                hide-details
                                            ></v-switch>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs4 align-content-left>
                                            <v-subheader><strong></strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 align-content-left>
                                            <v-btn :disabled="storeUserLoading || deleteUserLoading" :loading="loadingSkeniraj" color="success" @click="klikni_tukaj_za_skeniranje"><v-icon left>wifi</v-icon>Klikni tukaj za skeniranje</v-btn>
                                            <v-btn :disabled="loadingSkeniraj ||storeUserLoading" color="error" @click="odstrani_kartico"><v-icon left>clear</v-icon>Odstrani kartico</v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                                <br>

                                <!-- dovoljene lokacije -->
                                <v-toolbar
                                    card 
                                    color="grey lighten-4"
                                    dense
                                >
                                    <v-toolbar-title class="body-2"><v-icon medium>location_on</v-icon>   Dovoljene lokacije</v-toolbar-title>
                                </v-toolbar>
                                <v-container grid-list-xl text-x-center align-center>
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs4 align-content-center>
                                            <v-subheader><strong>Izberi tip omejitve</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 align-content-center>
                                            <v-select
                                                :items="tipi_omejitev"
                                                label="Tip omejitve"
                                                item-text="Naziv_omejitve"
                                                item-value="St_omejitve"
                                                v-model="tip_omejitve"
                                                persistent-hint
                                            ></v-select>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                                <br>

                                <!-- časovne omejitve -->
                                <v-toolbar
                                    card 
                                    color="grey lighten-4"
                                    dense
                                >
                                    <v-toolbar-title class="body-2"><v-icon medium>access_time</v-icon>   Časovne omejitve</v-toolbar-title>
                                </v-toolbar>
                                <v-container grid-list-xl text-x-center align-center>
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs6 align-content-center>
                                            <v-subheader><strong>Časovna omejitev</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 align-content-center>
                                            <v-switch
                                                v-model="casovna_omejitev"
                                                label="Upoštevaj časovno omejitev"
                                                color="primary"
                                                value="1"
                                                hide-details
                                            ></v-switch>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs6 align-content-center>
                                            <v-subheader><strong>Začetek časovne omejitve (izberi uro)</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 align-content-center>
                                            <v-menu
                                                ref="menu2"
                                                :close-on-content-click="false"
                                                v-model="menu2"
                                                :nudge-right="40"
                                                :return-value.sync="zacetek_casovne_omejitve"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                max-width="290px"
                                                min-width="290px"
                                                >
                                                <v-text-field
                                                    slot="activator"
                                                    v-model="zacetek_casovne_omejitve"
                                                    label="Začetek"
                                                    prepend-icon="access_time"
                                                    readonly
                                                ></v-text-field>
                                                <v-time-picker
                                                    v-if="menu2"
                                                    format="24hr"
                                                    v-model="zacetek_casovne_omejitve"
                                                    @change="$refs.menu2.save(zacetek_casovne_omejitve)"
                                                ></v-time-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs6 align-content-center>
                                            <v-subheader><strong>Konec časovne omejitve (izberi uro)</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 align-content-center>
                                            <v-menu
                                                ref="menu3"
                                                :close-on-content-click="false"
                                                v-model="menu3"
                                                :nudge-right="40"
                                                :return-value.sync="konec_casovne_omejitve"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                max-width="290px"
                                                min-width="290px"
                                                >
                                                <v-text-field
                                                    slot="activator"
                                                    v-model="konec_casovne_omejitve"
                                                    label="Konec"
                                                    prepend-icon="access_time"
                                                    readonly
                                                ></v-text-field>
                                                <v-time-picker
                                                    v-if="menu3"
                                                    format="24hr"
                                                    v-model="konec_casovne_omejitve"
                                                    @change="$refs.menu3.save(konec_casovne_omejitve)"
                                                ></v-time-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs6 align-content-center>
                                            <v-subheader><strong>Časovna omejitev zadrževanja (minute)</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 align-content-center>
                                            <v-text-field
                                                v-model="casovna_omejitev_zadrzanja"
                                                label="Čas  v minutah"
                                                required
                                                prepend-icon="hourglass_empty"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>
                        </v-card>
                        <br>
                        <v-btn
                            color="success"
                            @click="submit"
                            :loading="storeUserLoading"
                            :disabled="loadingSkeniraj || deleteUserLoading"
                        >
                        <v-icon left>update</v-icon>
                        Posodobi
                        </v-btn>
                        <v-btn 
                            color="error" 
                            @click="deleteUser"
                            :loading="deleteUserLoading"
                            :disabled="loadingSkeniraj || storeUserLoading"
                            >
                            <v-icon left>cancel</v-icon>
                            Izbriši uporabnika
                        </v-btn>
                    </v-form>
                </v-flex>
                <v-tooltip left>
                    <v-btn
                    fixed
                    dark
                    fab
                    bottom
                    right
                    color="light-blue darken-3"
                    @click="usersList"
                    slot="activator"
                    >
                    <v-icon>format_list_bulleted</v-icon>
                    </v-btn>
                    <span>Seznam uporabnikov</span>
                </v-tooltip>
            </v-layout>

            <!-- snackbar success -->
            <v-snackbar
                v-model="snackbar_success.display"    
                :bottom="snackbar_success.y === 'bottom'"
                :left="snackbar_success.x === 'left'"
                :multi-line="snackbar_success.mode === 'multi-line'"
                :right="snackbar_success.x === 'right'"
                :timeout="snackbar_success.timeout"
                :top="snackbar_success.y === 'top'"
                :vertical="snackbar_success.mode === 'vertical'"
            >
                {{ snackbar_success.text }}
                <v-btn
                color="pink"
                flat
                @click="snackbar_success.display = false"
                >
                Zapri
                </v-btn>
            </v-snackbar>

            <!-- snackbar error -->
            <v-snackbar
                v-model="snackbar_error.display"  
                :bottom="snackbar_error.y === 'bottom'"
                :left="snackbar_error.x === 'left'"
                :multi-line="snackbar_error.mode === 'multi-line'"
                :right="snackbar_error.x === 'right'"
                :timeout="snackbar_error.timeout"
                :top="snackbar_error.y === 'top'"
                :vertical="snackbar_error.mode === 'vertical'" 
                color="error"
            >
                {{ snackbar_error.text }}
                <v-btn
                dark
                flat
                @click="snackbar_error.display = false"
                >
                Zapri
                </v-btn>
            </v-snackbar>

            <v-dialog v-model="dialog" persistent max-width="490">
                <!--<v-btn slot="activator" color="primary" dark>Open Dialog</v-btn>-->
                <v-card>
                    <!--<v-card-title class="headline">Ste prepričani da želite izbrisati uporabnika?</v-card-title>-->
                    <v-card-text>
                    <v-icon flat>delete_forever</v-icon>
                    {{ dialog_text }}
                    </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-1" flat @click.native="dialogCancel()">Prekliči</v-btn>
                    <v-btn color="primary darken-1" flat @click.native="dialogConfirm()">Nadaljuj</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-container>
    </div>
</template>

<script>
export default {
    name: 'uporabnik',

    data() {
        return {
            
            user_uuid: this.$route.params.uuid, 
            valid: false,
            imetnik: '',
            ulica: '',
            kraj: '',
            telefonska_st: '',
            email: '',
            emso: '',
            davcna_st: '',
            registrska_st_1: '',
            registrska_st_2: '',
            registrska_st_3: '',
            registrska_st_4: '',
            registrska_st_5: '',
            prepoznava_tablic: null,
            id_kartice: '',
            serijska_st_kartice: '',
            st_kartice: '',
            kartica_blokirana: null,
            tip_omejitve: '',
            casovna_omejitev: null,
            zacetek_casovne_omejitve: null,
            konec_casovne_omejitve: null,
            casovna_omejitev_zadrzanja: '',

            dovolilnica_veljavnost_od: null,
            dovolilnica_veljavnost_do: null,
            dovolilnica_veljavnost_od_formatted: null,
            dovolilnica_veljavnost_do_formatted: null,

            menu_od: false,
            menu_do: false,
            menu2: false,
            menu3: false,
            storeUserLoading: false,
            deleteUserLoading: false,


            snackbar_success: {
                display: false,
                y: 'bottom',
                x: "left",
                mode: '',
                timeout: 6000,
                text: "Uporabnik  je bil uspešno vnesen v sistem.",
            },

            snackbar_error: {
                display: false,
                y: 'bottom',
                x: "left",
                mode: '',
                timeout: 6000,
                text: "Pri vnosu uporabnika v sistem je prišlo do napake.",
            },

            dialog: false,
            dialog_title: '',
            dialog_text: '',
            dialog_confirm: false,

            imetnikRules: [
                v => !!v || 'Polje imetnik je obvezno.',
            ],

            registrskaSt1Rules: [
                v => !!v || 'Vnos vsaj ene od registrskih številk je obvezen!',
            ],

            idKarticeRules: [
                v => (!!v) || 'Vnos ID kartice je obvezen!',
            ],

            id_kartice_enabled: false,
            serijska_st_kartice_enabled : false,
            loadingSkeniraj: false




        }
    },

    watch: {
        dovolilnica_veljavnost_od (val) {
            this.dovolilnica_veljavnost_od_formatted = this.formatDate(val)
        },

        dovolilnica_veljavnost_do (val) {
            this.dovolilnica_veljavnost_do_formatted = this.formatDate(val)
        }
    },

    computed: {

        inputIDkartice() {
            return (!this.id_kartice_enabled) ? true : false
        },

        inputSerijskaStkartice() {
            return (!this.serijska_st_kartice_enabled) ? true : false
        },

        contentLayout () {
            const binding = {}

            if(this.$vuetify.breakpoint.lgAndUp) {
            binding.column = false
            } else {
            binding.column = true
            }

            return binding;
        },
        
        columnBinding() {
            const binding = {}

            if (this.$vuetify.breakpoint.mdAndDown) binding.column = true

            return binding
        },

        tipi_omejitev () {
            return this.$store.getters.omejitve
        },

        getSerijskaStKartice() {
           if(this.serijska_st_kartice == null || this.serijska_st_kartice == '') return false

           return true
        }
    },

    methods: {
        submit() {
            if (this.$refs.form.validate()) {
                this.storeUserLoading = true
                //this.snackbar_success.text = '';
                this.$store.dispatch('UPDATE_RFID_UPORABNIK', {
                    imetnik: this.imetnik,
                    ulica: this.ulica,
                    kraj: this.kraj,
                    telefonska_st: this.telefonska_st,
                    email: this.email,
                    emso: this.emso,
                    davcna: this.davcna_st,
                    registrska_st_1: this.registrska_st_1,
                    registrska_st_2: this.registrska_st_2,
                    registrska_st_3: this.registrska_st_3,
                    registrska_st_4: this.registrska_st_4,
                    registrska_st_5: this.registrska_st_5,
                    prepoznava_tablic: this.prepoznava_tablic,
                    veljavnost_od: this.dovolilnica_veljavnost_od,
                    veljavnost_do: this.dovolilnica_veljavnost_do,
                    id_kartice: this.id_kartice,
                    serijska_st_kartice: this.serijska_st_kartice,
                    st_kartice: this.st_kartice,
                    kartica_blokirana: this.kartica_blokirana,
                    tip_omejitve: this.tip_omejitve,
                    casovna_omejitev: this.casovna_omejitev,
                    zacetek_casovne_omejitve: this.zacetek_casovne_omejitve,
                    konec_casovne_omejitve: this.konec_casovne_omejitve,
                    casovna_omejitev_zadrzanja: this.casovna_omejitev_zadrzanja,
                    uuid: this.user_uuid
                })
                    .then(response => {
                        //window.console.log('UPDATE_RFID_UPORABNIK success')
                        //window.console.log(response)
                        this.storeUserLoading = false
                        this.snackbar_success.text = "Uporabnik " + this.imetnik + ' je bil uspešno posodobljen!'
                        this.snackbar_success.mode = ''
                        this.snackbar_success.display = true
                        this.id_kartice_enabled = false
                    })
                    .catch(error => {
                        window.console.log('UPDATE_RFID_UPORABNIK error')
                        window.console.log(error)
                        this.storeUserLoading = false
                        this.snackbar_error.text = 'Pri posodobitvi uporabnika ' + this.imetnik + ' je prišlo do napake.'
                        this.snackbar_error.display = true
                    })
            } else {

                this.$vuetify.goTo('#updateForm', {
                    duration: 500,
                    offset: 0,
                    easing: 'easeInOutCubic'
                })
            }
        },

        deleteUser() {
            this.dialog_text = 'Ste prepričani da želite odstraniti uporabnika ' + this.imetnik + '?'
            this.dialog = true
        },

        dialogConfirm() {
        this.dialog_confirm = true
        this.dialog = false
        
        this.deleteUserLoading = true
        window.console.log("Deleting user...")
        this.$store.dispatch('DESTROY_RFID_UPORABNIK', this.user_uuid)
            .then(response => {
                //window.console.log(response)
                this.snackbar_success.text = 'Uporabnik ' + this.imetnik + ' je bil odstranjen iz sistema.'
                this.snackbar_success.display = true
                
                setTimeout(() => {
                    this.snackbar_success.display = false
                    this.deleteUserLoading = false
                    this.$router.push({
                        name: 'seznam-uporabnikov'
                    })
                }, 3000)
            })
            .catch(error => {
                window.console.log(error)
                this.snackbar_error.text = 'Pri brisanju uporabnika ' + this.imetnik + ' je prišlo do napake.'
                this.snackbar_error.display = true
                this.deleteUserLoading = false
            })
      
        },

        dialogCancel() {
            this.dialog_confirm = false
            this.dialog = false
        },


        klikni_tukaj_za_skeniranje() {
            this.odstrani_kartico()

            this.serijska_st_kartice_enabled = true

            setTimeout(() => {
                this.$refs.input_serijska_st_kartice.focus()
            },350)
        },

        odstrani_kartico() {
            this.id_kartice = null
            this.serijska_st_kartice = null
            this.st_kartice = null

            this.id_kartice_enabled = false
            this.serijska_st_kartice_enabled = false
            this.$refs.form.validate()
            this.$refs.input_serijska_st_kartice.blur()
            this.$refs.input_id_kartice.blur()

        },

        RfidNr() {
            let data = this.serijska_st_kartice
            this.st_kartice = this.serijska_st_kartice
            //this.serijska_st_kartice = convertRfidNr(data)
            this.loadingSkeniraj = true
            this.$store.dispatch('CONVERT_RFID_NR', { nr: data })
                .then(response => { 
                    //window.console.log(response)
                    this.serijska_st_kartice = response.data.rfidNr
                    this.loadingSkeniraj = false
                    this.snackbar_success.text = "Kartica uspešno poskenirana. Serijska številka kartice: " +  response.data.rfidNr + ". Vpišite še ID kartice."
                    this.snackbar_success.mode = 'multi-line'
                    this.snackbar_success.timeout = 9000
                    this.snackbar_success.display = true
                    this.id_kartice_enabled = true
            
                    setTimeout(() => {
                        this.$refs.input_id_kartice.focus()
                    }, 350)
                })
                .catch(error => {
                    window.console.log(error)
                    this.snackbar_error.text = 'Pri skeniranju kartice je prišlo do napake. Poskusite ponovno.'
                    this.snackbar_error.display = true
                    this.loadingSkeniraj = false
                })
            this.serijska_st_kartice_enabled = false
            
        },

        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}.${month}.${year}`
        },

        usersList() {
            this.$router.push({
                name: 'seznam-uporabnikov'
            })
        }
    },

    mounted() {
        this.$store.dispatch('OMEJITVE')
            .then(response => {
                //window.console.log("OMEJITVE")
                //window.console.log(response)
            })
            .catch(error => {
                window.console.log("OMEJITVE errors")
                window.console.log(error)
                    this.$toasted.show('Pri povezovanju s strežnikom je prišlo do napake. Za nadaljevanje ponovno osvežite stran.', {
                    position: 'bottom-right',
                    duration: 5000,
                    icon: 'error_outline',
                    theme: 'bubble', //['primary', 'outline' , 'bubble']
                    closeOnSwipe: true
                })
            }),

        window.console.log(this.user_uuid)
        this.$store.dispatch('GET_RFID_UPORABNIK', this.user_uuid)
            .then(response => {
                //window.console.log('GET_RFID_UPORABNIK success')
                //window.console.log(response)
                if(response.status == 200 && response.hasOwnProperty('data')) {
                    this.imetnik = response.data.user.imetnik
                    this.id_kartice = response.data.user.id_kartice
                    this.ulica = response.data.user.ulica
                    this.kraj = response.data.user.kraj
                    this.telefonska_st = response.data.user.telefonska_st
                    this.email = response.data.user.email
                    this.emso = response.data.user.emso
                    this.davcna_st = response.data.user.davcna
                    this.registrska_st_1 = response.data.user.registrska_st_1
                    this.registrska_st_2 = response.data.user.registrska_st_2
                    this.registrska_st_3 = response.data.user.registrska_st_3
                    this.registrska_st_4 = response.data.user.registrska_st_4
                    this.registrska_st_5 = response.data.user.registrska_st_5
                    this.dovolilnica_veljavnost_od = response.data.user.veljavnost_od
                    this.dovolilnica_veljavnost_do = response.data.user.veljavnost_do
                    this.id_kartice = response.data.user.id_kartice
                    this.serijska_st_kartice = response.data.user.serijska_st_kartice
                    this.kartica_blokirana = (response.data.user.kartica_blokirana == 1 || response.data.user.kartica_blokirana == '1') ? "1" : null
                    this.tip_omejitve = response.data.user.tip_omejitve
                    
                    if(response.data.user.casovna_omejitev == 1 || response.data.user.casovna_omejitev == '1') {
                        this.casovna_omejitev = "1"
                    }
                    else {
                        this.casovna_omejitev = null
                    }

                    if(response.data.user.prepoznava_tablic == 1 || response.data.user.prepoznava_tablic == '1') {
                        this.prepoznava_tablic = "1"
                    }
                    else {
                        this.prepoznava_tablic = null
                    }

                    this.zacetek_casovne_omejitve = response.data.user.zacetek_casovne_omejitve
                    this.konec_casovne_omejitve = response.data.user.konec_casovne_omejitve
                    this.casovna_omejitev_zadrzanja = response.data.user.casovna_omejitev_zadrzevanja
                }

            })
            .catch(error => {
                window.console.log("GET_RFID_UPORABNIK error")
                window.console.log(error)
            }),
        this.$refs.form.validate()
    },

    created() {

    }
}
</script>

<style scoped>
    h1, h2 {
        font-weight: normal;
    }
    ul {
        list-style-type: none;
        padding: 0;
    }
    li {
        display: inline-block;
        margin: 0 10px;
    }
    a {
        color: #42b983;
    }
</style>
</script>

<style scoped>

</style>


